export const API = process.env.REACT_APP_API
export const MOBILE_API = process.env.REACT_APP_MOBILE_API
export const IDENTITY_SERVER_URL = process.env.REACT_APP_IDENTITY_SERVER_URL
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID
export const CALLBACK_URL = process.env.REACT_APP_CALLBACK_URL
export const Measurement_ID = process.env.REACT_APP_MEASUREMENT_ID

